import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ userByPhone }: RootState) => userByPhone;

export const selectUsersByPhone = createSelector(
    selectRoot,
    ({ userByPhone }) => userByPhone,
);
